// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* body{
    background-color: #f7f6f6;
  } */
.btnstyle {
  margin: 20px;
}

.btnpopup {
  color: #fff;
  background-color: #71d0ba;
  font-weight: 400;
  border-radius: 6px;
  border: none;
  float: right;
  box-shadow: 2px 3px 9px #6a6a6a;
}
.cardstyle {
  border: none !important;
  /* box-shadow: 1px 2px 3px #b0a7a7; */
  /* background: white; */
  margin-top: 18px;
  display: flex;
  flex-direction: column;
}
.below-average-row {
  background-color: #71d0ba; /* Customize the background color as desired */
  border-radius: 200px;
  color: red;
  font-style: bold;
}
.below-average-row:hover {
  color: #333;
  font-style: italic;
  font-weight: 600;
}
.chart-container {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  /* height: 404px; */
  display: flex;
  justify-content: center;
}
.tblshade {
  box-shadow: 2px 2px 2px #c4b9b9;
  border-radius: 6px;
  padding-top: 20px;
}

.check-btn {
  width: max-content !important;
}

.sync-view-container {
  width: 90%;
  margin: 4.5rem auto 2.5rem auto;
}

.sync-view-container .sec .card {
  padding: 16px 24px !important;
}

.sync-view-container .sec-title {
  font-size: 30px;
}

.sync-view-container .custom-input {
  width: 100%;
  min-height: 38px;
  background-color: hsl(0, 0%, 100%);
  /* border-color: hsl(0, 0%, 80%); */
  border-radius: 4px;
  border: 1px solid hsl(0, 0%, 80%);
}

.sync-view-container .sec .btn-success {
  margin: 20px 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/pages/syncOverview.css"],"names":[],"mappings":"AAAA;;KAEK;AACL;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,yBAAyB,EAAE,8CAA8C;EACzE,oBAAoB;EACpB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,mCAAmC;EACnC,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* body{\n    background-color: #f7f6f6;\n  } */\n.btnstyle {\n  margin: 20px;\n}\n\n.btnpopup {\n  color: #fff;\n  background-color: #71d0ba;\n  font-weight: 400;\n  border-radius: 6px;\n  border: none;\n  float: right;\n  box-shadow: 2px 3px 9px #6a6a6a;\n}\n.cardstyle {\n  border: none !important;\n  /* box-shadow: 1px 2px 3px #b0a7a7; */\n  /* background: white; */\n  margin-top: 18px;\n  display: flex;\n  flex-direction: column;\n}\n.below-average-row {\n  background-color: #71d0ba; /* Customize the background color as desired */\n  border-radius: 200px;\n  color: red;\n  font-style: bold;\n}\n.below-average-row:hover {\n  color: #333;\n  font-style: italic;\n  font-weight: 600;\n}\n.chart-container {\n  width: 100%;\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 20px;\n  /* height: 404px; */\n  display: flex;\n  justify-content: center;\n}\n.tblshade {\n  box-shadow: 2px 2px 2px #c4b9b9;\n  border-radius: 6px;\n  padding-top: 20px;\n}\n\n.check-btn {\n  width: max-content !important;\n}\n\n.sync-view-container {\n  width: 90%;\n  margin: 4.5rem auto 2.5rem auto;\n}\n\n.sync-view-container .sec .card {\n  padding: 16px 24px !important;\n}\n\n.sync-view-container .sec-title {\n  font-size: 30px;\n}\n\n.sync-view-container .custom-input {\n  width: 100%;\n  min-height: 38px;\n  background-color: hsl(0, 0%, 100%);\n  /* border-color: hsl(0, 0%, 80%); */\n  border-radius: 4px;\n  border: 1px solid hsl(0, 0%, 80%);\n}\n\n.sync-view-container .sec .btn-success {\n  margin: 20px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
